<template>
  <!-- 管理员订单管理 -->
  <div class="RefundRequestDetail">
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <el-scrollbar class="scrollbar" style="
        height: calc(100% - 50px);
        padding-top: 20px;
        box-sizing: border-box;
      ">
      <div class="main">
        <div class="adorder_xiang">
          <span>退单编号：{{ row.lsh }}</span>
          <span class="adorder_tui_sp" v-if="productList.length && listOrdetil.TypeStatus == 1"
            @click="refund('0')">驳回</span>
        </div>
        <div class="adorder_list">
          <p class="adorder_list_s">退货商品列表</p>
          <div class="adorder_table">
            <p class="adorder_list_hd" style="background: #f4f4f4">
              <span class="adorder_hd_bian">产品名</span>
              <span class="adorder_hd_num">国药准字</span>
              <span class="adorder_hd_changjia">厂家</span>
              <span class="adorder_hd_heji">规格</span>
              <span class="adorder_hd_ming">数量</span>
              <span class="adorder_hd_gui">单价</span>
              <span class="adorder_hd_chang">退率</span>
              <span class="adorder_hd_price">单品退款</span>
            </p>
            <p class="adorder_list_hd" v-for="(item, index) in productList" :key="index">
              <span class="adorder_hd_bian">{{ item.sub_title }}</span>
              <span class="adorder_hd_num">{{ item.approval_number }}</span>
              <span class="adorder_hd_changjia">{{ item.drug_factory }}</span>
              <span class="adorder_hd_heji">{{ item.drug_spec }}</span>
              <span class="adorder_hd_ming">{{ item.Quantity }}</span>
              <span class="adorder_hd_gui">{{ item.Price }}</span>
              <span class="adorder_hd_chang">{{ item.Discount }}</span>
              <span class="adorder_hd_price" style="border-right: 1px solid #f4f4f4">{{ item.Amount }}</span>
            </p>
          </div>
          <p class="adorder_list_s" style="margin-top: 20px">凭证</p>
          <div class="image-gallery">
            <div v-if="imageList.length > 0" class="image-content">
              <div class="image-container">
                <div class="image-item" v-for="(item, index) in imageList" :key="index"
                  @click="previewImage(item.image_url)">
                  <img :src="item.image_url" alt="商品图片" />
                  <div class="image-index">图{{ index + 1 }}</div>
                </div>
              </div>
              <div class="image-tip">点击图片可放大查看</div>
            </div>
            <div v-else class="no-images">
              暂无商品图片
            </div>
          </div>
          <p class="adorder_list_s" style="margin-top: 20px">收货信息</p>
          <div>
            <div class="add_shou">
              <p><span>订单号</span>{{ listOrdetil.order_no }}</p>
              <p><span>下单时间</span>{{ listOrdetil.add_time }}</p>
            </div>
            <div class="add_shou">
              <p><span>账号</span>{{ listOrdetil.username }}</p>
              <p><span>单位名称</span>{{ listOrdetil.businessname }}</p>
            </div>
            <div class="add_shou">
              <p><span>姓名</span>{{ listOrdetil.name }}</p>
              <p><span>手机</span>{{ listOrdetil.telphone }}</p>
            </div>
            <div class="add_shou">
              <p><span>渠道</span>{{ listOrdetil.Source }}</p>
              <p><span>退单金额</span>{{ listOrdetil.tallAmount }}</p>
            </div>
          </div>
          <div class="adorder_tui" v-if="productList.length && listOrdetil.TypeStatus == 1">
            <span @click="handlePass">退款</span>
            <!-- <span class="adorder_tui_sp" @click="refund('0')">驳回</span> -->
          </div>
        </div>
      </div>
    </el-scrollbar>
    <!-- 图片预览弹窗 -->
    <el-dialog :visible.sync="previewVisible" :close-on-click-modal="false" width="80%" top="5vh"
      class="image-preview-dialog">
      <div class="preview-content">
        <img :src="currentPreviewImage" alt="预览图片" class="preview-image" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="previewVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//网络
export default {
  name: "refundRequestDetail",
  data() {
    return {
      orderNos: this.$route.query.row, //订单号
      row: "",
      listOrdetil: {}, //收货信息
      productList: [], //商品列表
      imageList: [], //商品图片列表
      previewVisible: false, //图片预览弹窗是否显示
      currentPreviewImage: "", //当前预览图片
    };
  },
  mounted() {
    let row = JSON.parse(decodeURIComponent(this.$route.query.row));
    if (row) {
      this.row = row;
      this.getorderDetail();
    } else {
      //执行注册
    }
  },
  methods: {
    updata() {
      if (this.row) {
        this.getorderDetail();
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    getorderDetail() {
      let data = {
        type: "GetReturnMoneyDetail",
        strwhere: this.row.lsh,
      };
      let proc = "proc_OrderQuery"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "qualification/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            if (res.table0 && res.table0.length > 0) {
              const firstItem = res.table0[0]
              this.listOrdetil = {
                order_no: firstItem.order_no,
                add_time: firstItem.add_time,
                username: firstItem.username,
                businessname: firstItem.businessname,
                name: firstItem.name,
                telphone: firstItem.telphone,
                Source: firstItem.Source,
                tallAmount: firstItem.tallAmount || firstItem.Amount,
                TypeStatus: firstItem.TypeStatus,
                lsh: firstItem.lsh,
              };
              this.productList = res.table0.map(item => ({
                sub_title: item.sub_title,
                approval_number: item.approval_number,
                drug_factory: item.drug_factory,
                drug_spec: item.drug_spec,
                Quantity: item.Quantity,
                Price: item.Price,
                Discount: item.Discount,
                Amount: item.Amount,
                lsh: item.lsh,
              }));
            }
            if (res.table1 && res.table1.length > 0) {
              const firstTable1Item = res.table1[0];
              if (firstTable1Item.RefImg && typeof firstTable1Item.RefImg === 'string') {
                // 分割字符串，得到图片URL数组
                const imgUrls = firstTable1Item.RefImg.split(',').map(url => url.trim());
                // 对每张图片进行处理
                this.imageList = imgUrls.map((imgUrl, index) => ({
                  image_url: this.$setImgUrl(imgUrl),
                  original_url: imgUrl, // 保存原始URL，便于调试
                  index: index + 1
                }));
              }
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**退款通过 */
    handlePass() {
      this.$confirm("确定要退款吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            lsh: this.row.lsh,
            // orderNo: this.row.lsh,
          };

          this.$request({
            method: "post",
            // url: "Apliay/UnionRefuldApi",
            url: "AllinPay/AllinPayRefund",
            data,
            dataType: "json",
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.goBack();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },

    // 驳回(之前通过和驳回都是用的这个接口，现在通过不使用这个接口了)
    refund(status) {
      let proc = "proc_OrderQuery"; // 存储过程名
      let type = "ReturnNumber";

      let data = {
        type: "Pc_SetReturnMoney",
        strwhere: this.row.lsh,
        source: this.row.source,
        uptype: status,
        amount: this.row.Amount,
      };
      let url =
        "article/ashx/ReturnJson.ashx?type=" +
        type +
        "&json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        proc;
      let tips = "确定要退款吗？";
      let msgType = "success";
      if (status == 0) {
        data = {
          type: "RefundAuditRefuse",
          strwhere: this.row.lsh,
        };
        url =
          "ashx/MainReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc;
        tips = "确定要驳回吗？";
        msgType = "warning";
      }

      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: msgType,
      })
        .then(() => {
          this.$requestSys({
            method: "post",
            url: url,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.goBack();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**预览图片 */
    previewImage(imgUrl) {
      console.log('imgUrl',imgUrl);
      this.currentPreviewImage =imgUrl;
      this.previewVisible = true;
    },
  },
};
</script>

<style scoped>
.RefundRequestDetail {
  width: 100%;
  height: 100%;
}

.main {
  width: 100%;
}

/* 头部 */
.adorder_xiang {
  margin: 20px 20px 0px 20px;
  padding: 10px;
  background: #f4f4f4;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.adorder_list {
  width: 100%;
  margin: 20px;
  padding: 0 10px;
}

.adorder_table {
  width: 100%;
}

.adorder_list_hd {
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #f4f4f4;
}

.adorder_list_hd span {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  color: #333;
  font-size: 14px;
  text-align: center;
  border-left: 1px solid #f4f4f4;
}

.adorder_list_s {
  margin-bottom: 20px;
}

.adorder_hd_bian {
  width: 24%;
}

.adorder_hd_num {
  width: 24%;
}

.adorder_hd_changjia {
  width: 30%;
}

.adorder_hd_heji {
  width: 24%;
}

.adorder_hd_ming {
  width: 20%;
}

.adorder_hd_gui {
  width: 20%;
}

.adorder_hd_price {
  width: 20%;
}

.adorder_hd_chang {
  width: 20%;
}

.add_shou {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #f4f4f4;
  border-right: 1px solid #f4f4f4;
  border-left: 1px solid #f4f4f4;
}

.add_shou p {
  flex: 0 0 50%;
  display: inline-block;
  /* padding: 0 0px; */
  color: #333;
  font-size: 14px;
}

.add_shou p span {
  display: inline-block;
  background: #f4f4f4;
  padding: 10px 0px;
  font-size: 14px;
  width: 100px;
  text-align: center;
  margin-right: 10px;
}

.adorder_tui {
  margin: 20px 20px;
}

.adorder_tui > span {
  display: inline-block;
  width: 80px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  color: #ffffff;
  background-color: #5eb95e;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
}

.adorder_tui_sp {
  display: inline-block;
  width: 80px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  color: #ffffff;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  margin-left: 20px;
  background-color: #f56c6c;
}
/* 图片 */
.image-gallery {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 20px;
}

.image-content {
  display: inline-block;
}

.image-container {
  display: inline-flex;
  flex-wrap: nowrap;
  gap: 10px;
  margin-right: 15px;
}

.image-item {
  width: 80px;
  height: 80px;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ddd;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.image-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-color: #409EFF;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-index {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  text-align: center;
  font-size: 12px;
  padding: 2px 0;
}

.image-tip {
  display: inline-block;
  font-size: 12px;
  color: #666;
  vertical-align: middle;
}

.no-images {
  display: inline-block;
  color: #999;
  font-style: italic;
  vertical-align: middle;
}
</style>
